export const SET_ASSESSMENT = "SET_ASSESSMENT";

export const setAssessment = (assessment) => ({type: SET_ASSESSMENT, assessment});
